module.exports = __webpack_public_path__ + "img/IMG_5897.bb6a749b.jpg";